let environment = process.env.REACT_APP_ENVIRONMENT || 'development'

export default environment